enum Department {
  All = 'All',
  'Data Analytics' = 'Data Analytics',
  Design = 'Design',
  Engineering = 'Engineering',
  Finance = 'Finance',
  International = 'International',
  Marketing = 'Marketing',
  Operations = 'Operations',
  People = 'People',
  Product = 'Product'
}

export { Department };
